import createReactComponent from '../createReactComponent';
export default createReactComponent('letter-j-small', 'IconLetterJSmall', [
  ['path', { d: 'M10 8h4v6a2 2 0 1 1 -4 0', key: 'svg-0' }],
]);
